/**
 * Hook that returns the current frame relative to the enclosing Sequence.
 *
 * If used outside a Sequence, returns the absolute frame.
 * Inside a Sequence, subtracts the cumulated offset so children
 * always see frame 0 at the start of their Sequence.
 *
 * Written from scratch for Steve.AI.
 */

import { useContext } from 'react';
import { SequenceContext } from './SequenceContext.js';
import { useTimelinePosition } from './timeline-position-state.js';

export const useCurrentFrame = () => {
  const absoluteFrame = useTimelinePosition();
  const sequenceCtx = useContext(SequenceContext);

  if (!sequenceCtx) {
    return absoluteFrame;
  }

  const offset = sequenceCtx.cumulatedFrom + sequenceCtx.relativeFrom;
  return absoluteFrame - offset;
};
